import { useBooleanFlagDetails, useBooleanFlagValue } from '@openfeature/react-sdk';

export type FeatureFlagKey =
  | 'emergency-alarm-toggle'
  | 'antons-amazing-segment'
  | 'new-audit-log'
  | 'multi-org'
  | 'lwt-sender-screen-2026-web';

/**
 * Returns the boolean value of a flag. Returns defaultValue if the flag is
 * unreachable, disabled, or does not exist.
 */
export const useFeatureFlag = (key: FeatureFlagKey, defaultValue = false): boolean =>
  useBooleanFlagValue(key, defaultValue);

/**
 * Returns full evaluation details including reason and errorCode.
 * Use errorCode === ErrorCode.FLAG_NOT_FOUND to distinguish
 * "flag is off" from "flag does not exist in the backend".
 */
export const useFeatureFlagDetails = (key: FeatureFlagKey, defaultValue = false) =>
  useBooleanFlagDetails(key, defaultValue);
